/**
 * Free-text genre → the homepage's 5-book strip (Thriller/Romance/Sci-Fi/Fantasy/Literary —
 * a different, smaller set than cover-showcase's 6, so it gets its own small resolver rather
 * than reusing resolve-genre.js's mapping). Same match + honest-fallback shape throughout
 * this codebase (resolve-genre.js, resolve-style.js) and the real backend's resolveGenre().
 */
const STRIP_KEYWORDS = [
  ['Thriller', /thriller|suspense|crime|mystery|detective|spy|espionage|noir|heist/i],
  ['Romance', /romance|love story|rom[- ]?com|romantic/i],
  ['Sci-Fi', /sci[- ]?fi|science fiction|space|dystopia|cyberpunk|ai\b|robot/i],
  ['Fantasy', /fantasy|magic|dragon|epic|ya\b|young adult|sword/i],
  ['Literary', /literary|memoir|poetry|business|nonfiction|self[- ]?help|contemporary|drama/i],
];

/**
 * @param {string} input free-text genre
 * @param {string[]} labels ordered labels matching the strip's book order
 * @returns {{ index: number, label: string, matched: boolean }}
 */
export function resolveGenreToStripIndex(input, labels) {
  const text = (input || '').trim();
  if (text) {
    for (const [label, re] of STRIP_KEYWORDS) {
      if (re.test(text)) {
        const index = labels.indexOf(label);
        if (index !== -1) return { index, label, matched: true };
      }
    }
  }
  const fallbackIndex = labels.indexOf('Literary');
  return { index: fallbackIndex === -1 ? 0 : fallbackIndex, label: 'Literary', matched: false };
}
